<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';
import error403 from '../utility/error-403';

import {
  required,
  //email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, error403 },
  props:{
    id:[Number,null],
    rights: Array
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Company",
          href: "/"
        },
        {
          text: "Job Positions",
          href: "/company/jobpositions"
        },
        {
          text: "Job Position",
          active: true
        }
      ],
      form: {
        id_company: "",
        id_site: "",
        id_department: "",
        id_levelJobPosition: "",
        nm_jobTitle: "",
        de_jobPosition: ""
      },
      submitted: false,
      validToken: true,
      validAccess: true,
      companies: [],
      sites: [],
      departments: [],
    };
  },
  validations: {
    form: {
      id_company: { required },
      id_site: { required },
      id_department: { required },
      id_levelJobPosition: { required },
      nm_jobTitle: {required, minLength: minLength(2), maxLength: maxLength(50)},
      de_jobPosition: {required, minLength: minLength(100), maxLength: maxLength(2048)},
    }
  },
  watch:{
    validToken(newValue){
      if( newValue == false ){
        this.$bvModal.show('loginModal');
      }
    },
    "rights": function(newvalue, oldvalue){
      if(oldvalue !== newvalue){
        if(!newvalue.includes(this.user.user.id_role)){
          this.validAccess = false;
        }else{
          this.validAccess = true;
        }
      }
    }
  },
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    if( this.$route.params.id ){
      this.getJobPosition();
    }else{
      this.getCompanies();
    }
  },
  methods: {
    async getCompanies(){
      Swal.fire({
        title: "Loading Companies",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/organizations.php',
        {
          params: {
            request: 'getOrganizationsForCombos',
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            app.companies = response.data;
            Swal.close();
          }
        }else{
          Swal.fire("Ooops!", "It was not possible to load Companies! Please load this module again.", "error");
        }
      });
    },

    async getSites(){
      let app = this;

      Swal.fire({
        title: "Loading Sites",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/sites.php',
        {
          params: {
            request: 'getSitesByCompanyID',
            idCompany: this.form.id_company,
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            app.sites = response.data;
            Swal.close();
          }
        }else{
          Swal.fire("Ooops!", "It was nor possible to load Countries! Please load this module again.", "error");
        }
      });
    },

    async getDepartmentsBySiteID(){
      let app = this;

      Swal.fire({
        title: "Loading Departments",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/departments.php',
        {
          params: {
            request: 'getDepartmentsBySiteID',
            idSite: this.form.id_site,
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
        if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
        if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }

        if( response.status == 200 ){
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            app.departments = response.data;
            Swal.close();
          }
        }else{
          Swal.fire("Ooops!", "It was nor possible to load States! Please load this module again.", "error");
        }
      });
    },
    
    async getJobPosition(){
      Swal.fire({
        title: "Loading job position.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/jobpositions.php',
        {
          params: {
            request: 'getJobPosition',
            id: this.$route.params.id,
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          if( response.data == 'Invalid token'){
            this.validToken = false;
          }else{
            app.jobPosition = response.data;
            this.form.id_company                    = app.jobPosition.id_company;
            this.form.id_site                       = app.jobPosition.id_site;
            this.form.id_department                 = app.jobPosition.id_department;
            this.form.id_levelJobPosition           = app.jobPosition.id_levelJobPosition;
            this.form.nm_jobTitle                   = app.jobPosition.nm_jobTitle;
            this.form.de_jobPosition                = app.jobPosition.de_jobPosition;
            Swal.close();
            this.getCompanies();
            this.getSites();
            this.getDepartmentsBySiteID();
          }
        }else{
          Swal.fire("Ooops!", "It was nor possible to load States! Please load this module again.", "error");
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    saveJobPosition(e) {
      let app = this;

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_jobPosition = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving site.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/jobpositions.php', {
          request: 'saveJobPosition',
          data: this.form,
          token: this.user.token,
        })
        .then(function (response) {
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            let action = "";
            if( response.data === "OK" ){
              action = "saved";
            }
            if( response.data === "UPDATED" ){
              action = "updated";
            }
            Swal.fire("Good job!", "Your JOb Position is correct "+action+"!", "success");
            app.$router.push({ name: 'job-positions' });
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    },
    resetFromCompany(){
      this.sites                    = [];
      this.departments              = [];
      this.form.id_site             = "";
      this.form.id_department       = "";
      this.form.id_levelJobPosition = "";
    },
    resetFromSite(){
      this.departments              = [];
      this.form.id_department       = "";
      this.form.id_levelJobPosition = "";
    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div v-if="validAccess" class="card-body">
            <form class="needs-validation" @submit.prevent="saveJobPosition">
              <div class="row">
                <div class="col-lg-4">
                  <!--<h4 class="card-title">Department Data</h4>-->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="id_company">{{$t('menuitems.jobpositions.list.company')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_company.$error }"
                          name="id_company"
                          id="id_company"
                          v-model="form.id_company"
                          @change="resetFromCompany();getSites()"
                        >
                          <option value="">{{$t('menuitems.jobpositions.list.selectCompany')}}</option>
                          <option v-for="(company, index) in companies" :key="index" :value="company.id_company">{{company.nm_company}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_company.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_company.required">Company field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_site">{{$t('menuitems.jobpositions.list.site')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_site.$error }"
                          name="id_site"
                          id="id_site"
                          v-model="form.id_site"
                          @change="resetFromSite();getDepartmentsBySiteID()"
                        >
                          <option value="">{{$t('menuitems.jobpositions.list.selectSite')}}</option>
                          <option v-for="(site, index) in sites" :key="index" :value="site.id_site">{{site.nm_site}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_site.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_site.required">Site is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_department">{{$t('menuitems.jobpositions.list.department')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_department.$error }"
                          name="id_department"
                          id="id_department"
                          v-model="form.id_department"
                        >
                          <option value="">{{$t('menuitems.jobpositions.list.selectDepartment')}}</option>
                          <option v-for="(department, index) in departments" :key="index" :value="department.id_department">{{department.nm_department}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_department.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_department.required">Site is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_levelJobPosition">{{$t('menuitems.jobpositions.list.positionLevel')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_levelJobPosition.$error }"
                          name="id_levelJobPosition"
                          id="id_levelJobPosition"
                          v-model="form.id_levelJobPosition"
                        >
                          <option value="">{{$t('menuitems.jobpositions.list.selectPositionLevel')}}</option>
                          <option value="1">{{$t('menuitems.jobpositions.list.topManagement')}}</option>
                          <option value="2">{{$t('menuitems.jobpositions.list.siteDirector')}}</option>
                          <option value="3">{{$t('menuitems.jobpositions.list.manager')}}</option>
                          <option value="4">{{$t('menuitems.jobpositions.list.supervisor')}}</option>
                          <option value="5">{{$t('menuitems.jobpositions.list.employee')}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_levelJobPosition.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_levelJobPosition.required">Level Position is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_jobTitle">{{$t('menuitems.jobpositions.list.jobTitleName')}}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_jobTitle.$error }"
                          name="nm_jobTitle"
                          id="nm_jobTitle"
                          v-model="form.nm_jobTitle"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_jobTitle.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_jobTitle.required">Department name is required.</span>
                          <span v-if="!$v.form.nm_jobTitle.minLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                          <span v-if="!$v.form.nm_jobTitle.maxLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--
                  <p class="card-title-desc">To understand better your company, please provide each department of your current site. This will help you to know your Departmental Structure.</p>
                  -->
                </div>

                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="de_jobPosition">{{$t('menuitems.jobpositions.list.jobPositionDescription')}}</label>
                        <textarea
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_jobPosition.$error }"
                          name="de_jobPosition"
                          id="de_jobPosition"
                          v-model="form.de_jobPosition"
                          rows="17"
                          value=""
                        >
                        </textarea>
                        <div v-if="submitted && $v.form.de_jobPosition.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_jobPosition.required">Address field is required.</span>
                          <span v-if="!$v.form.de_jobPosition.minLength">This value length is invalid. It should be between 100 and 200 characters long.</span>
                          <span v-if="!$v.form.de_jobPosition.maxLength">This value length is invalid. It should be between 100 and 200 characters long.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card-title">&nbsp;</div>
                    <p class="card-title-desc">{{$t('menuitems.jobpositions.list.importance')}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">{{$t('menuitems.jobpositions.list.save')}}</button>
                    <router-link to="/company/jobpositions" class="ml-3">
                      <button class="btn btn-danger" type="reset">{{$t('menuitems.jobpositions.list.cancel')}}</button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div v-else class="card-body">
            <div class="row">
              <div class="col-sm-12 text-center">
                <error403></error403>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>